import React, { useState } from 'react';
import { NoticeBar } from 'antd-mobile';

import { useAuth } from '../../../hooks/use-auth';
import { faroLogger } from '../../../observability/faro-logger';

const APOS = '’';

const Login = () => {
  const auth = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!username.trim() || !password) {
      return;
    }
    faroLogger.info('login_attempt', { username });
    auth.signin(username.trim(), password);
  };

  return (
    <div className="agent-login-root">
      <div className="agent-login-wrap">
        <div className="agent-login-logo">
          <span className="agent-login-logo-text">
            Camion<span>net</span>
          </span>
          <span className="agent-login-logo-sig">by lz net</span>
        </div>

        <div className="agent-login-card">
          <h2 className="agent-login-title">Connexion agent</h2>

          {auth.errors.map((err) => (
            <div className="agent-login-notice" key={err}>
              <NoticeBar content={err} color="alert" closeable />
            </div>
          ))}

          <form onSubmit={onSubmit}>
            <label className="agent-login-label" htmlFor="agent-login-username">
              Identifiant
            </label>
            <input
              id="agent-login-username"
              type="text"
              autoComplete="username"
              autoCorrect="off"
              autoCapitalize="none"
              spellCheck={false}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Votre identifiant"
              className="agent-login-input"
            />

            <label className="agent-login-label" htmlFor="agent-login-password">
              Mot de passe
            </label>
            <input
              id="agent-login-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={'••••••••'}
              className="agent-login-input"
            />

            <button
              type="submit"
              disabled={auth.isLoading}
              className="agent-login-btn"
            >
              {auth.isLoading ? 'Connexion...' : 'Se connecter'}
            </button>

            <div className="agent-login-help">
              {'Identifiants oubliés ? '}
              <a href="mailto:contact@camionnet.fr?subject=Mot%20de%20passe%20oublie%20App%20Agent">
                Contactez-nous
              </a>
            </div>
          </form>
        </div>

        <div className="agent-login-branding">
          <div className="agent-login-eyebrow">
            <span className="agent-login-dot" /> Saisie agent
          </div>
          <h1 className="agent-login-headline">
            {'Chaque intervention '}
            <span>compte.</span>
          </h1>
          <p>
            {'Vos saisies sont visibles temps reel par le client et generent sa facture.'}
          </p>
          <ul className="agent-login-features">
            <li>Saisie rapide des interventions</li>
            <li>Photos plaques et numéro de parc</li>
            <li>{`Synchronisation en temps réel avec l${APOS}espace client`}</li>
            <li>Facturation automatique à partir des interventions que vous saisissez</li>
          </ul>
        </div>

        <div className="agent-login-footer">
          <b>SAS LZ NET CAMION NET</b>
          <br />
          contact@camionnet.fr - lavagecamions.com
        </div>
      </div>

      <style>{loginStyles}</style>
    </div>
  );
};

const loginStyles = `
.agent-login-root {
  min-height: 100vh;
  background:
    radial-gradient(ellipse at top right, rgba(49,220,200,0.14) 0%, transparent 55%),
    radial-gradient(ellipse at bottom left, rgba(28,48,96,0.55) 0%, transparent 55%),
    #0B1628;
  color: #fff;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  letter-spacing: -0.005em;
  padding: 28px 16px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.agent-login-wrap {
  width: 100%;
  max-width: 440px;
}
.agent-login-logo {
  text-align: center;
  margin-bottom: 26px;
}
.agent-login-logo-text {
  display: block;
  font-weight: 900;
  font-size: 32px;
  letter-spacing: -0.03em;
  color: #fff;
  line-height: 1;
}
.agent-login-logo-text > span {
  color: #31DCC8;
}
.agent-login-logo-sig {
  display: block;
  font-family: 'Caveat', cursive;
  color: #31DCC8;
  font-size: 18px;
  margin-top: 4px;
}
.agent-login-card {
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 20px;
  padding: 28px 22px;
  box-shadow: 0 24px 60px rgba(0,0,0,0.35);
  margin-bottom: 28px;
}
.agent-login-title {
  font-size: 26px;
  font-weight: 900;
  letter-spacing: -0.02em;
  margin: 0 0 20px;
  color: #fff;
}
.agent-login-notice {
  margin-bottom: 14px;
}
.agent-login-label {
  display: block;
  font-size: 12.5px;
  font-weight: 600;
  color: rgba(248,250,251,0.85);
  margin-bottom: 6px;
  margin-top: 14px;
}
.agent-login-label:first-of-type {
  margin-top: 0;
}
.agent-login-input {
  width: 100%;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 12px;
  padding: 13px 14px;
  color: #fff;
  font-size: 16px;
  font-family: inherit;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
}
.agent-login-input::placeholder {
  color: rgba(248,250,251,0.4);
}
.agent-login-input:focus {
  border-color: #31DCC8;
  box-shadow: 0 0 0 3px rgba(49,220,200,0.18);
  background: rgba(255,255,255,0.06);
}
.agent-login-btn {
  width: 100%;
  margin-top: 22px;
  padding: 14px 16px;
  background: #31DCC8;
  color: #0B1628;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: -0.005em;
  cursor: pointer;
  font-family: inherit;
  box-shadow: 0 6px 18px rgba(49,220,200,0.35);
  transition: background 0.15s, transform 0.05s;
}
.agent-login-btn:hover {
  background: #5DEEDF;
}
.agent-login-btn:active {
  transform: translateY(1px);
}
.agent-login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.agent-login-help {
  text-align: center;
  margin-top: 16px;
  font-size: 13px;
  color: rgba(248,250,251,0.55);
}
.agent-login-help a {
  color: #31DCC8;
  font-weight: 600;
  text-decoration: none;
}
.agent-login-branding {
  padding-top: 28px;
  border-top: 1px solid rgba(255,255,255,0.06);
}
.agent-login-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #31DCC8;
  margin-bottom: 16px;
}
.agent-login-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #31DCC8;
  box-shadow: 0 0 12px rgba(49,220,200,0.6);
}
.agent-login-headline {
  font-size: 32px;
  font-weight: 900;
  letter-spacing: -0.03em;
  line-height: 1.05;
  color: #fff;
  margin: 0 0 14px;
}
.agent-login-headline > span {
  color: #31DCC8;
}
.agent-login-branding p {
  font-size: 15px;
  line-height: 1.55;
  color: rgba(248,250,251,0.7);
  margin: 0 0 18px;
}
.agent-login-features {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.agent-login-features li {
  color: rgba(248,250,251,0.85);
  font-size: 14px;
  font-weight: 500;
  padding-left: 24px;
  position: relative;
}
.agent-login-features li::before {
  content: '\\2713';
  position: absolute;
  left: 0;
  top: 0;
  color: #31DCC8;
  font-weight: 800;
}
.agent-login-footer {
  margin-top: 28px;
  font-size: 11px;
  color: rgba(248,250,251,0.45);
  text-align: center;
  line-height: 1.6;
}
.agent-login-footer b {
  color: rgba(248,250,251,0.7);
}
@media (min-width: 720px) {
  .agent-login-wrap {
    max-width: 480px;
  }
  .agent-login-card {
    padding: 36px 32px;
  }
}
`;

export default Login;
